"use client"

import { useState } from "react"
import { Copy, Edit, FileText, Save, X } from "lucide-react"
import Markdown from "react-markdown"
import remarkGfm from "remark-gfm"
import useUserStore from "../../store/useUserStore"
import "./SummaryView.css"



export const SummaryView = ({ summary, consultationId, onUpdateSummary ,setShowPopUp,selectedType}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editedSummary, setEditedSummary] = useState(summary)
  const [summaryType, setSummaryType] = useState(["Summary","Summary","Summary"])
  const {isMobile} = useUserStore()


  const handleEdit = () => {
    setIsEditing(true)
    setEditedSummary(summary)
  }

  const handleSave = async () => {
    try {
      await onUpdateSummary(consultationId, editedSummary, "Final Summary")
      setIsEditing(false)
    } catch (error) {
      console.error("Error saving summary:", error)
    }
  }

  const handleCancel = () => {
    setIsEditing(false)
    setEditedSummary(summary)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(summary)
  }

  return (
    <div className="summary-container">
      <div className="summary-header">
        <p className="summary-title">Summary</p>
        <div className="summary-actions">
          <div className="dropdown-container">
            <button className="change-summary-button" onClick={() => setShowPopUp(true)}>
              <FileText size={isMobile?14:18} />
              {isMobile ? "Change" : "Change Summary"}
            </button>
          </div>
          {isEditing ? (
            <>
              <button className="summary-action-button" onClick={handleCancel}>
                <X size={isMobile?14:18} />
                Cancel
              </button>
              <button className="summary-action-button save-button" onClick={handleSave}>
                <Save size={isMobile?14:18} />
                Save
              </button>
            </>
          ) : (
            <>
              <button className="summary-action-button" onClick={handleCopy}>
                <Copy size={isMobile?14:18} />
                Copy
              </button>
              <button className="summary-action-button" onClick={handleEdit}>
                <Edit size={isMobile?14:18} />
                Edit
              </button>
            </>
          )}
        </div>
      </div>

      <div className="summary-content">
        {isEditing ? (
          <textarea
            value={editedSummary}
            onChange={(e) => setEditedSummary(e.target.value)}
            className="summary-editor"
          />
        ) : (
          <Markdown remarkPlugins={[remarkGfm]} className="markdown-content">
            {summary}
          </Markdown>
        )}
      </div>
    </div>
  )
}

